import React from "react";
import "./Search.css";

// Pending Images Upload

function Search(){

    return(
        <div className="contents">
  <div className="container">
  {/* <!-- Row 1: Three Cards --> */}
  <div className="row justify-content-center g-4">
    <div className="col-md-4">
      <div className="cardid card border border-dark">

                      <div className="corner-circle"></div>

        <div className="card-body">
          <h5 className="card-title">
              <img src="socialmedia.png" alt="Logo"/>
       On-Page SEO</h5>
          <p className="card-text">We optimize your website’s structure, content, and HTML elements like titles, meta tags, headings, and internal links. This ensures that every page is search engine-friendly and provides a great user experience. A well-optimized page ranks higher and keeps visitors engaged.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className=" cardid card  border border-dark">

                      <div className="corner-circle "></div>

        <div className="card-body">
         <h5 className="card-title">
        <img src="searchengine.png" alt="Logo"/>
           Off-Page SEO (Backlink Building)</h5>
          <p className="card-text">
       We build high-quality backlinks from trusted websites to improve your domain authority and online reputation. Strong backlinks boost<br/>
        your website’s credibility in search engines, <br/>
        helping it climb to the top of search results organically.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="Google.png" alt="Logo"/>
       Technical SEO</h5>
          <p className="card-text">We improve the backend structure of your website by fixing errors, increasing loading speed, ensuring mobile responsiveness, enabling HTTPS security, and improving crawlability. These technical enhancements help search engines understand and rank your site better.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="row justify-content-center g-4 mt-3">
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="content.png" alt="Logo"/>
          Local SEO</h5>
          <p className="card-text">We help your business show up in local searches by optimizing your Google Business Profile, adding local keywords, and getting your business listed on local directories. Ideal for Coimbatore-based businesses looking to attract more nearby customers.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="email.png" alt="Logo"/>
       Keyword Research & Strategy</h5>
          <p className="card-text">We identify the most relevant, high-performing keywords your audience is searching for. Our keyword strategy focuses on bringing targeted traffic that converts into real leads or sales, giving your business a competitive edge.</p>
        </div>
      </div>
    </div>
  </div>
</div>


<button type="button" className="exitbutton btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Move to Previous
</button>


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Exit page</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      Are You Really want to Exit this page..
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary">Yes</button>
      </div>
    </div>
  </div>
</div>


        </div>
    )

}
export default Search;